import SvgIcon from "@material-ui/core/SvgIcon";

export const CustomEnFlagIcon = (props) => {
    return (
        <SvgIcon width="25" height="16" viewBox="0 0 25 16" fill="none" {...props}>
            <g clip-path="url(#clip0_1589_32829)">
                <path d="M24.2432 0H0.243164V16.0002H24.2432V0Z" fill="white"/>
                <path d="M13.7432 0H10.7432V6.49997H0.243164V9.49997H10.7432V15.9999H13.7432V9.49997H24.2432V6.49997H13.7432V0Z" fill="#D80027"/>
                <path d="M18.7026 10.7822L24.244 13.8608V10.7822H18.7026Z" fill="#0052B4"/>
                <path d="M14.8525 10.7822L24.2439 15.9996V14.5243L17.5082 10.7822H14.8525Z" fill="#0052B4"/>
                <path d="M21.7423 15.9996L14.8525 12.1716V15.9996H21.7423Z" fill="#0052B4"/>
                <path d="M14.8525 10.7822L24.2439 15.9996V14.5243L17.5082 10.7822H14.8525Z" fill="#F0F0F0"/>
                <path d="M14.8525 10.7822L24.2439 15.9996V14.5243L17.5082 10.7822H14.8525Z" fill="#D80027"/>
                <path d="M4.4779 10.7822L0.243164 13.1349V10.7822H4.4779Z" fill="#0052B4"/>
                <path d="M9.63441 11.4457V15.9996H1.43799L9.63441 11.4457Z" fill="#0052B4"/>
                <path d="M6.97877 10.7822L0.243164 14.5243V15.9996L9.63448 10.7822H6.97877Z" fill="#D80027"/>
                <path d="M5.78449 5.21736L0.243164 2.13879V5.21736H5.78449Z" fill="#0052B4"/>
                <path d="M9.63448 5.21737L0.243164 0V1.47534L6.97877 5.21737H9.63448Z" fill="#0052B4"/>
                <path d="M2.74463 0L9.63441 3.828V0H2.74463Z" fill="#0052B4"/>
                <path d="M9.63448 5.21737L0.243164 0V1.47534L6.97877 5.21737H9.63448Z" fill="#F0F0F0"/>
                <path d="M9.63448 5.21737L0.243164 0V1.47534L6.97877 5.21737H9.63448Z" fill="#D80027"/>
                <path d="M20.0093 5.2174L24.244 2.86475V5.2174H20.0093Z" fill="#0052B4"/>
                <path d="M14.8525 4.55395V0H23.049L14.8525 4.55395Z" fill="#0052B4"/>
                <path d="M17.5082 5.21737L24.2439 1.47534V0L14.8525 5.21737H17.5082Z" fill="#D80027"/>
            </g>
            <defs>
                <clipPath id="clip0_1589_32829">
                    <rect x="0.243164" width="24.0007" height="16.0002" rx="2" fill="white"/>
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
